import { ApplicationConfig, provideBrowserGlobalErrorListeners, provideZonelessChangeDetection } from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideRouter } from '@angular/router';

import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';

import { provideConfigService } from 'app/shared/providers';
import { httpTraceInterceptor, authInterceptor, langHeaderInterceptor } from 'app/shared/interceptors';

import { routes } from './app.routes';

const DEFAULT_LANG = 'en';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideRouter(routes),
    provideHttpClient(
      withInterceptors([
        authInterceptor,
        langHeaderInterceptor,
        httpTraceInterceptor,
      ])
    ),
    provideConfigService({
      urls: [
        '/config/application.json',
      ],
      preload: true,
    }),
    provideTranslateService({
      loader: provideTranslateHttpLoader({
        prefix: '/i18n/',
        suffix: '.json',
      }),
      fallbackLang: DEFAULT_LANG,
    }),
  ]
};
